import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    fontSize: 16,
    display: 'block',
    cursor: 'pointer',
    width: 22,
    height: 20,
    background: 'none',
    border: 'none',
    '& span': {
      width: 22,
      left: 0,
      height: 2,
      background: theme.palette.secondary.main,
      borderRadius: 5,
      transition: 'all 0.2s',
      position: 'absolute',
    },
    '& span:first-child': {
      transform: 'rotate(-45deg) translateX(1px)',
      top: '50%',
    },
    '& span:last-child': {
      transform: 'rotate(45deg) translateX(2px)',
      bottom: '50%',
    },
    '&:focus': {
      outline: 0,
    },
  },
}));

interface Props {
  togglePopup: (props: any) => void;
}

const CloseButton: React.FC<Props> = ({ togglePopup }) => {
  const classes = useStyles();

  return (
    <button onClick={() => togglePopup(false)} type="button" className={classes.closeButton}>
      <span />
      <span />
    </button>
  );
};

export default CloseButton;
